import { Component } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FirestoreService} from './services/firestore.service';
import {Observable} from 'rxjs';
import { ToastService } from './services/toast.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent {
  navBar$: Observable<Object>;
  navBar: Iterable<any> = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private firestoreService: FirestoreService,
    private toastService: ToastService
  ) {
    this.navBar$ = this.firestoreService.getSiteNav('navBar');
    this.navBar$.subscribe((value: any) => { this.navBar = value });
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }
}
